import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import SearchIcon from "@mui/icons-material/Search";
import {
  Box,
  Button,
  Container,
  InputAdornment,
  Pagination,
  PaginationItem,
  Stack,
  TextField,
  Typography,
  Tooltip,
} from "@mui/material";
import ConfirmationModel from "components/ConfirmationModel";
import FilterBar from "components/FilterBar";
import Loader from "components/Loader";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  changePagination,
  deleteClientById,
  getClients,
  searchClients,
  SET_CLIENT_FITNESS_PROGRAMS,
} from "store/actions/clients";
import { setHeaderDetails } from "store/actions/header";
import { clientStatuses } from "utils/programs.utils";
import ClientListBody from "./ClientsListBody";
import ClientListHeader from "./ClientsListHeader";
import useSubscriptionGuard from "hooks/useSubscriptionGuard";
import InviteClient from "./InviteClient";

const MyClientsList = () => {
  const { canCreate } = useSubscriptionGuard();
  const dispatch = useDispatch();
  const clients = useSelector((state) => state.clients.clients);
  const isLoadingClients = useSelector(
    (state) => state.clients.isLoadingClients
  );
  const currentPage = useSelector((state) => state.clients.currentPage);
  const [current, setCurrent] = useState(null);
  const [showDeleteModel, setDeleteModel] = useState(false);
  const [showInviteClientModal, setShowInviteClientModal] = useState(false);
  const start = (currentPage - 1) * 10;
  const end = start + 10;
  const currentPageItems = (clients || []).slice(start, end).length;
  const [filters, setFilters] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");

  const toggleDeleteModel = (ele = "") => {
    setDeleteModel(!showDeleteModel);
    setCurrent(ele);
  };

  const toggleInviteClientModal = () => {
    setShowInviteClientModal(!showInviteClientModal);
  };
  useEffect(() => {
    dispatch(getClients());
    const navDetail = {
      isBreadcrumns: false,
      title: "Clients",
    };
    dispatch({
      type: SET_CLIENT_FITNESS_PROGRAMS,
      payload: [],
    });

    dispatch(setHeaderDetails(navDetail));
  }, []);
  const getStatusFilterValues = (values) => {
    setFilters(values);
    dispatch(searchClients(searchQuery, values));
  };
  return (
    <>
      <Container
        maxWidth="xxl"
        className="header-box"
        sx={{ padding: "0 !important", marginBottom: "20px" }}
      >
        <Stack
          direction={{ xs: "column", sm: "row" }}
          alignItems={{ xs: "stretch", sm: "center" }}
          justifyContent="space-between"
          gap={1}
          mt={2}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            alignItems={{ xs: "stretch", sm: "center" }}
            justifyContent="space-between"
            gap={1}
          >
            <TextField
              placeholder="Rechercher un client"
              name="Rechercher un client"
              size="small"
              sx={{
                width: { sm: "100%", md: "414px" },
                ".MuiInputBase-root": {
                  background: "#ffffff",
                  borderRadius: "8px",
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="#4F5668" />
                  </InputAdornment>
                ),
              }}
              onChange={(e) => {
                setSearchQuery(e.target.value);
                dispatch(searchClients(e.target.value, filters));
              }}
            />
            <FilterBar
              filters={[
                { title: "Statut", list: clientStatuses, onSelect: getStatusFilterValues },
              ]}
            />
          </Stack>
          <Tooltip title={!canCreate ? "Mettez à jour votre abonnement pour accéder à cette fonctionnalité" : ""}>
            <Box
              component="span"
              sx={{
                display: { xs: "block", sm: "inline-block" },
                width: { xs: "100%", sm: "auto" },
              }}
            >
              <Button
                size="small"
                color="primary"
                variant="contained"
                disabled={!canCreate}
                sx={{ width: "100%" }}
                onClick={() => {
                  setShowInviteClientModal(true);
                }}
              >
                Ajouter un client
              </Button>
            </Box>
          </Tooltip>
        </Stack>
      </Container>
      <Container maxWidth="xxl">
        <Stack gap={1}>
          <Loader isLoading={isLoadingClients} />
          {!isLoadingClients && <ClientListHeader />}
          {(clients || []).length === 0 && !isLoadingClients && (
            <Box component="h5" textAlign="center">
              Vous n'avez pas encore de clients.
            </Box>
          )}

          {!isLoadingClients && (
            <Box sx={{ minHeight: "544px" }}>
              {(clients || []).slice(start, end).map((client, index) => (
                <ClientListBody
                  key={client._id}
                  client={client}
                  toggleDeleteModel={toggleDeleteModel}
                />
              ))}
            </Box>
          )}
          {!isLoadingClients && (clients || []).length > 10 && (
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Typography color="#000000" fontSize="12px" fontWeight="500">
                Affichage de {start + 1} à {start + currentPageItems} sur{" "}
                {clients.length} résultats
              </Typography>
              <Pagination
                page={currentPage}
                onChange={(page, value) => dispatch(changePagination(value))}
                count={Math.ceil(clients.length / 10)}
                variant="outlined"
                shape="rounded"
                color="secondary"
                size="small"
                siblingCount={0}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                    {...item}
                  />
                )}
              />
            </Stack>
          )}
        </Stack>
        <InviteClient
          showModal={showInviteClientModal}
          toggleInviteClientModal={toggleInviteClientModal}
        />
        <ConfirmationModel
          isOpen={showDeleteModel}
          title="Supprimer Client"
          body={[
            "Vous allez supprimer ce client. Cette action est irréversible. Pour continuer, cliquez sur Supprimer.",
          ]}
          handleClose={toggleDeleteModel}
          maxWidth="sm"
          onConfirm={() => {
            dispatch(deleteClientById(current._id, toggleDeleteModel)).then(
              () => toggleDeleteModel()
            );
          }}
        />
      </Container>
    </>
  );
};

export default MyClientsList;
